var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticStyle:{"font-size":".9em"}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('contact-picker',{attrs:{"disabled":_vm.disabled,"can-create":false,"can-clear":true,"type":_vm.type},on:{"input":_vm.relay},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }